import React, { Component } from "react";
import MainMenu from "../components/mainMenu";
import SubNavigation from "../components/subNavigation";
import TopBanner from "../components/topBanner";
import AnimatedBackground from "../components/animatedBackground";
import InstagramFeed from "../components/instagramFeed";
import Footer from "../components/footer";

export default class SuitSpeedSkating extends Component {
	constructor(props) {
		super(props);
	}

	componentDidMount() {
		document.title = "QwixSkinz || Speed Skating Race Suits";
	}
	componentWillUnmount() {}

	render() {
		return (
			<React.Fragment>
				<MainMenu />
				<TopBanner
					bannerHeight="full"
					title="Speed Skating Suit"
					images={["speedskate/speedSkateBanner.jpg"]}
				/>
				<SubNavigation
					location={this.props.location}
					refs={this.refs}
					navItems={[
						{ title: "Suit Overview", id: "overview" },
						{ title: "Performance Benefits", id: "performance" }
					]}
				/>
				{/* Bobsled Suit Overview */}
				<div className="qs-b" ref="overview">
					<div className="container block-wrap behind-trees">
						<div className="d-flex flex-row flex-wrap align-items-stretch">
							<div className="col-12 content dark pb-0">
								<div className="section-title">
									<h1 className="title">Long Track Speed Skating Race Suits</h1>
								</div>
							</div>
							<div className="col-12 content dark pt-0">
								<p className="lead">
									The Qwixskinz Speed Skate suits are produced for 2 levels of
									competition.
								</p>

								<p>
									Our national level race suit is for the athlete that requires
									the best in aerodynamic construction while providing a
									durability &amp; more accommodating fit that the national level
									skater requires throughout a season. Our Speed Skate Race
									suits have been refined with scientific data as well as input
									from top aerodynamic engineers for the best fit and
									performance qualities
								</p>
								<ul>
									<li>
										Top quality fabric to assure fit and performance benefits
									</li>
									<li>
										Combination of textured aerodynamic sit panels &amp; coated
										spandex torso panels for the elite race suit composition
									</li>
									<li>
										Ergonomically fit hood allows for a comfortable head
										position
									</li>
								</ul>
								<p>
									Our new Elite race suit will be unveiled later in 2018 &amp; will
									be the product of an exciting new collaboration with the best
									team in speed skating aerodynamics &amp; design.
								</p>
								<p>The world of speed skating is overdue for something new!</p>
							</div>
						</div>
					</div>
				</div>



				{/* Performace Section */}
				<div className="qs-b" ref="performance">
					<div className="container block-wrap behind-trees">
						<div className="d-flex flex-row flex-wrap align-items-stretch">
							<div className="col-12 content dark pb-0">
								<div className="section-title">
									<h1 className="title">Performance Benefits</h1>
								</div>
							</div>
							<div className="col-12 content dark pt-0">
								<p className="lead">
									With Speed Skating, Qwixskinz has used the same approach to
									developing the highest quality race suits as possible.
								</p>
								<p>
									An initial 2 year pattern development phase has now been taken
									one step further with the 3D pattern technology that has
									revolutionized the notoriously difficult fit of the Long Track
									Speed Skate race suit. Our ability to wrap the skater’s 3D
									form with the pattern pieces &amp; move through the skating motion
									allows for target areas to be adjusted where needed. At the
									end of the day, if an aerodynamic race suit does not FIT
									correctly, it is not fast. Wind tunnel testing has proven
									that. Our Qwixskinz LT Speed Skate suit aims to end that
									dilema.
								</p>
							</div>
						</div>
					</div>
				</div>

				<InstagramFeed  />
				<Footer />
				<AnimatedBackground />
			</React.Fragment>
		);
	}
}
